import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';


import ContactForm from './ContactForm';
import { contactUs } from '../../ducks/ContactUs.duck';

import css from './ContactUsPage.module.css';

const ContactUsPageComponent = props => {

  const { submitContact, contactUsSuccess, contactUsError } = props;

  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About AllCourse',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.root} id='contact' name='contact' >
            <h1 className={css.contactUsPageTitle}>
              <FormattedMessage id="ContactUsPage.title" />
            </h1>
            <p className={css.contactUsPageDescription}>
              <FormattedMessage id="ContactUsPage.description1" />
            </p>
            <p className={css.contactUsPageDescription}>
              <FormattedMessage id="ContactUsPage.description2" />
            </p>

            <h2 className={css.formTitle}>
              <FormattedMessage id="ContactUsPage.formTitle" />
            </h2>
            <ContactForm
              className={css.form}
              onSubmit={submitContact}
              contactUsError={contactUsError}
              contactUsSuccess={contactUsSuccess}
            />
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

const { func } = PropTypes;

ContactUsPageComponent.propTypes = {
  submitContact: func.isRequired,
};

const mapStateToProps = state => {
  const { contactUsError, contactUsSuccess } = state.ContactUs;
  return {
    contactUsError, contactUsSuccess
  };
};

const mapDispatchToProps = dispatch => ({
  submitContact: ({ email, name, message }) => dispatch(contactUs(email, name, message)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const ContactUsPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
)(ContactUsPageComponent);

export default ContactUsPage;
